import {
  AhuComponentCatalogTable,
  AhuComponentCatalogTableFilters,
  useDefaultHtzAhuComponentCatalogListRequest,
} from "@/services/backend/htz/ahu/components/ahu-component-catalog-table";
import { NewComponentCatalogDialog } from "@/services/backend/htz/ahu/components/new-component-catalog-dialog";
import { ComponentKindsTable } from "@/services/backend/htz/ahu/components/component-kinds-table";
import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import t from "@/lang/lang";
import { NavLink } from "react-router";
import { ReactNode, useCallback, useState } from "react";

export function AhuComponentCatalogsRoute() {
  const [request, setRequest] = useState(
    useDefaultHtzAhuComponentCatalogListRequest(),
  );

  const renderRowLink = useCallback(
    (catalogId: string, children: ReactNode) => (
      <NavLink to={catalogId}>{children}</NavLink>
    ),
    [],
  );

  return (
    <div className="space-y-2">
      <ComponentKindsTable />
      <Card>
        <CardHeader>
          <CardTitle>{t("Kataloge für Anlagenkomponenten")}</CardTitle>
          <CardDescription>
            {t(
              "Hier können Sie Kataloge mit Vorlagen zur Definition von Komponenten für RLT-Anlagen verwalten.",
            )}
          </CardDescription>
          <CardAction>
            <NewComponentCatalogDialog />
          </CardAction>
        </CardHeader>
        <CardContent className="grid gap-2">
          <AhuComponentCatalogTableFilters
            request={request}
            onRequestChange={setRequest}
          />
          <AhuComponentCatalogTable
            request={request}
            onRequestChange={setRequest}
            renderRowLink={renderRowLink}
            hideBorder
          />
        </CardContent>
      </Card>
    </div>
  );
}
